import React, { FC, PropsWithChildren } from "react";

import { useEmbedParametersContext } from "../contexts/EmbedParametersContext";
import { useMediaContext } from "../contexts/MediaContext";
import { getAreenaUrl } from "../helpers/areenaLinks";
import { localizedText } from "../helpers/previewHelpers";
import i18n from "../service/i18n";
import { usePlayerStore } from "../store/usePlayerStore";

import { NotAllowedLinkVideo } from "./NotAllowedButton/NotAllowedButtonVideo";
import {
  localizedLogo,
  Overlay,
  OverlayLogo,
  OverlayTop
} from "./VideoPreviewOverlay";

const NotAllowed: FC<PropsWithChildren> = ({ children }) => {
  const { useStoreState } = usePlayerStore();
  const programId = useStoreState.programId();
  const isSimulcast = useStoreState.isSimulcast();
  const { title } = useMediaContext();
  const { language } = useEmbedParametersContext();
  const areenaLink = programId
    ? getAreenaUrl({
        isSimulcast,
        language,
        programId
      })
    : "";
  const areenaLinkLabel = i18n("linkki_yle_areenaan", { language });
  return (
    <>
      <Overlay isVisible={false}>
        <OverlayTop>
          <span>
            {children}
            {localizedText(title, language)}
          </span>
        </OverlayTop>
        <OverlayLogo
          aria-label={areenaLinkLabel}
          localizedLogo={localizedLogo(language)}
          href={areenaLink}
        />
      </Overlay>
      <NotAllowedLinkVideo />
    </>
  );
};

export default NotAllowed;
